import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { LiveMatchState } from './models/liveMatch';
import {
  ResponseLiveCompetitions,
  ResponseLiveMatch,
} from '../../services/api/models/response/responseLiveMatch';
import { IResponseLive } from '../../services/api/models/response/responseLive';

const defaultLiveMatchState: LiveMatchState = {
  isShowListMatch: false,
  isShowLiveMatchRequest: false,
  isShowLiveMatchLiver: false,
  isLiveMatch: false,
  widthTicker: 105,
  isFinishLiveCompetition: false,
  isShowEndLiveMatchModal: false,
  isEndLiveMatch: false,
  userLiveReturn: [],
};
const liveMatchSlice = createSlice({
  name: 'liveMatchSlice',
  initialState: defaultLiveMatchState,
  reducers: {
    toggleLiveMatchList: (
      state: LiveMatchState,
      action: PayloadAction<boolean>,
    ) => {
      state.isShowListMatch = action.payload;
    },
    toggleLiveMatchRequest: (
      state: LiveMatchState,
      action: PayloadAction<boolean>,
    ) => {
      state.isShowLiveMatchRequest = action.payload;
    },
    toggleEndLiveMatchModal: (
      state: LiveMatchState,
      action: PayloadAction<boolean>,
    ) => {
      state.isShowEndLiveMatchModal = action.payload;
    },
    toggleLiveMatchLiverModal: (
      state: LiveMatchState,
      action: PayloadAction<boolean>,
    ) => {
      state.isShowLiveMatchLiver = action.payload;
    },
    startLiveMatchNotice: (
      state: LiveMatchState,
      action: PayloadAction<boolean>,
    ) => {
      state.isLiveMatch = action.payload;
    },
    endLiveMatchNotice: (
      state: LiveMatchState,
      action: PayloadAction<boolean>,
    ) => {
      state.isEndLiveMatch = action.payload;
    },
    updateWidthTicker: (
      state: LiveMatchState,
      action: PayloadAction<number>,
    ) => {
      state.widthTicker = action.payload;
    },
    updateLiveMatchStatus: (
      state: LiveMatchState,
      action: PayloadAction<string>,
    ) => {
      state.statusLiveMatch = action.payload;
    },
    updateLiveMatchData: (
      state: LiveMatchState,
      action: PayloadAction<ResponseLiveMatch | undefined>,
    ) => {
      state.liveMatchData = action.payload;
    },
    updateLiveCompetitions: (
      state: LiveMatchState,
      action: PayloadAction<ResponseLiveCompetitions | undefined>,
    ) => {
      state.liveCompetitions = action.payload;
    },
    updateUserRequestMatch: (
      state: LiveMatchState,
      action: PayloadAction<IResponseLive | undefined>,
    ) => {
      state.userRequestMatch = action.payload;
    },
    updateFinishLiveCompetition: (
      state: LiveMatchState,
      action: PayloadAction<boolean>,
    ) => {
      state.isFinishLiveCompetition = action.payload;
    },
    resetDataLiveMatch: (state: LiveMatchState) => {
      state.liveMatchData = undefined;
      state.liveCompetitions = undefined;
      state.isShowListMatch = false;
      state.isShowLiveMatchRequest = false;
      state.isShowLiveMatchLiver = false;
      state.isFinishLiveCompetition = false;
      state.isShowEndLiveMatchModal = false;
      state.isEndLiveMatch = false;
      state.statusLiveMatch = undefined;
      state.userRequestMatch = undefined;
      state.userLiveReturn = [];
    },
    addUserLiveReturn: (
      state: LiveMatchState,
      action: PayloadAction<string>,
    ) => {
      state.uriLiveReturn =
        state.userLiveReturn[state.userLiveReturn.length - 1];
      state.userLiveReturn.push(action.payload);
    },
    updateUserLiveReturn: (
      state: LiveMatchState,
      action: PayloadAction<boolean>,
    ) => {
      if (state.userLiveReturn.length <= 1 || action?.payload) {
        state.userLiveReturn = [];
      } else {
        state.userLiveReturn = state.userLiveReturn.slice(0, -2);
      }
    },
  },
});
export const {
  toggleLiveMatchList,
  toggleLiveMatchRequest,
  toggleEndLiveMatchModal,
  toggleLiveMatchLiverModal,
  startLiveMatchNotice,
  endLiveMatchNotice,
  updateLiveMatchData,
  updateLiveMatchStatus,
  updateUserRequestMatch,
  updateLiveCompetitions,
  updateFinishLiveCompetition,
  resetDataLiveMatch,
  addUserLiveReturn,
  updateUserLiveReturn,
  updateWidthTicker,
} = liveMatchSlice.actions;
export const LiveMatchReducer = liveMatchSlice.reducer;
